<template>
  <div class="resource-store-use-record-manage-container">
    <ds-page-header :title="$t('resourceStoreUseRecordManage.page.title')"
      :subtitle="$t('resourceStoreUseRecordManage.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-download" @click="_exportExcel">
          {{ $t('common.export') }}
        </el-button>
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="_queryResourceStoreUseRecordMethod">
          {{ $t('common.refresh') }}
        </el-button>
      </template>
    </ds-page-header>

    <ds-search-panel>
      <el-row :gutter="16">
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.rsurId"
            :placeholder="$t('resourceStoreUseRecordManage.search.rsurId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.repairId"
            :placeholder="$t('resourceStoreUseRecordManage.search.repairId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.resId"
            :placeholder="$t('resourceStoreUseRecordManage.search.resId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.resName"
            :placeholder="$t('resourceStoreUseRecordManage.search.resName')" clearable />
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="resourceStoreUseRecordManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.createUserId"
            :placeholder="$t('resourceStoreUseRecordManage.search.createUserId')" clearable />
        </el-col>
        <el-col :span="6">
          <el-input v-model="resourceStoreUseRecordManageInfo.conditions.createUserName"
            :placeholder="$t('resourceStoreUseRecordManage.search.createUserName')" clearable />
        </el-col>
        <el-col :span="6">
          <el-select v-model="resourceStoreUseRecordManageInfo.conditions.parentRstId"
            :placeholder="$t('resourceStoreUseRecordManage.search.parentRstId')" style="width:100%"
            @change="_listResourceStoreSonTypes" clearable>
            <el-option v-for="item in resourceStoreUseRecordManageInfo.resourceStoreTypes" :key="item.rstId"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="resourceStoreUseRecordManageInfo.conditions.rstId"
            :placeholder="$t('resourceStoreUseRecordManage.search.rstId')" style="width:100%"
            @change="_listResourceStoreSpecifications" clearable>
            <el-option v-for="item in resourceStoreUseRecordManageInfo.resourceStoreSonTypes" :key="item.rstId"
              :label="item.name" :value="item.rstId" />
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="16" v-show="resourceStoreUseRecordManageInfo.moreCondition" style="margin-top:16px;">
        <el-col :span="6">
          <el-select v-model="resourceStoreUseRecordManageInfo.conditions.rssId"
            :placeholder="$t('resourceStoreUseRecordManage.search.rssId')" style="width:100%" clearable>
            <el-option v-for="item in resourceStoreUseRecordManageInfo.resourceStoreSpecifications" :key="item.rssId"
              :label="item.specName" :value="item.rssId" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="resourceStoreUseRecordManageInfo.conditions.state"
            :placeholder="$t('resourceStoreUseRecordManage.search.state')" style="width:100%" clearable>
            <el-option v-for="item in resourceStoreUseRecordManageInfo.states" :key="item.statusCd" :label="item.name"
              :value="item.statusCd" />
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="resourceStoreUseRecordManageInfo.conditions.startTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('resourceStoreUseRecordManage.search.startTime')"
            style="width:100%" />
        </el-col>
        <el-col :span="6">
          <el-date-picker v-model="resourceStoreUseRecordManageInfo.conditions.endTime" type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$t('resourceStoreUseRecordManage.search.endTime')"
            style="width:100%" />
        </el-col>
      </el-row>
      <template #actions>
        <el-button type="primary" size="small" icon="el-icon-search" @click="_queryResourceStoreUseRecordMethod">
          {{ $t('common.search') }}
        </el-button>
        <el-button size="small" icon="el-icon-refresh" @click="_resetResourceStoreUseRecordMethod">
          {{ $t('common.reset') }}
        </el-button>
        <el-button size="small" type="text" @click="_moreCondition">
          {{ resourceStoreUseRecordManageInfo.moreCondition ? $t('common.hide') : $t('common.more') }}
          <i :class="resourceStoreUseRecordManageInfo.moreCondition ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
        </el-button>
      </template>
    </ds-search-panel>

    <div class="ds-panel">
      <ds-toolbar :total="resourceStoreUseRecordManageInfo.total" :density="density" :show-column-setting="false"
        @update:density="density = $event" @refresh="_listResourceStoreUseRecords">
        <template #left>
          <span class="ds-panel__title">{{ $t('resourceStoreUseRecordManage.list.title') }}</span>
        </template>
        <template #right>
          <el-button size="mini" icon="el-icon-download" @click="_exportExcel">
            {{ $t('common.export') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="resourceStoreUseRecordManageInfo.resourceStoreUseRecords" :loading="loading"
        :error="hasError" :error-message="errorMessage" :density="density" border
        :empty-description="$t('resourceStoreUseRecordManage.page.empty')" @retry="_listResourceStoreUseRecords">
        <el-table-column prop="rsurId" :label="$t('resourceStoreUseRecordManage.table.rsurId')" align="center" width="120">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.rsurId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="repairId" :label="$t('resourceStoreUseRecordManage.table.repairId')" align="center" width="130">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.repairId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="resId" :label="$t('resourceStoreUseRecordManage.table.resId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.resId || '-' }}</span></template>
        </el-table-column>
        <el-table-column :label="$t('resourceStoreUseRecordManage.table.resourceType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName || '-' }} &gt; {{ scope.row.rstName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceStoreUseRecordManage.table.resourceStoreName')" align="center" min-width="130">
          <template slot-scope="scope">{{ scope.row.resourceStoreName || '-' }}</template>
        </el-table-column>
        <el-table-column :label="$t('resourceStoreUseRecordManage.table.specName')" align="center" width="110">
          <template slot-scope="scope">{{ scope.row.specName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('resourceStoreUseRecordManage.table.isFixedName')" align="center" width="100" />
        <el-table-column prop="stateName" :label="$t('resourceStoreUseRecordManage.table.stateName')" align="center" width="110">
          <template slot-scope="scope">
            <ds-status-tag size="sm" type="info" :label="scope.row.stateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceStoreUseRecordManage.table.quantity')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.quantity }}{{ scope.row.miniUnitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('resourceStoreUseRecordManage.table.unitPrice')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.unitPrice || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUserId" :label="$t('resourceStoreUseRecordManage.table.createUserId')" align="center" width="110">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createUserId || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="createUserName" :label="$t('resourceStoreUseRecordManage.table.createUserName')" align="center" width="110" />
        <el-table-column prop="createTime" :label="$t('resourceStoreUseRecordManage.table.createTime')" align="center" width="170">
          <template slot-scope="scope"><span class="ds-num">{{ scope.row.createTime || '-' }}</span></template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('resourceStoreUseRecordManage.table.remark')" align="center" min-width="130">
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
      </ds-data-table>
      <ds-pagination-bar :page="page.current" :size="page.size" :total="resourceStoreUseRecordManageInfo.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import { listResourceStoreUseRecords, listResourceStoreTypes, listResourceStoreSpecifications, exportData } from '@/api/resource/resourceStoreUseRecordManageApi'
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsSearchPanel from '@/components/ds/ds-search-panel.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsPaginationBar from '@/components/ds/ds-pagination-bar.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ResourceStoreUseRecordManageList',
  components: { DsPageHeader, DsSearchPanel, DsToolbar, DsDataTable, DsPaginationBar, DsStatusTag },
  data() {
    return {
      loading: false,
      hasError: false,
      errorMessage: '',
      density: 'default',
      resourceStoreUseRecordManageInfo: {
        resourceStoreUseRecords: [],
        total: 0,
        records: 1,
        moreCondition: false,
        states: [],
        conditions: {
          rsurId: '',
          repairId: '',
          resId: '',
          resName: '',
          parentRstId: '',
          rstId: '',
          rssId: '',
          createUserId: '',
          createUserName: '',
          startTime: '',
          endTime: '',
          state: '',
          userId: '',
          userName: '',
          communityId: ''
        },
        resourceStoreTypes: [],
        resourceStoreSonTypes: [],
        resourceStoreSpecifications: []
      },
      page: {
        current: 1,
        size: 10
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.resourceStoreUseRecordManageInfo.conditions.communityId = this.communityId
    this._initMethod()
  },
  methods: {
    async _initMethod() {
      try {
        this.loading = true
        await this.getDictData()
        await this._listResourceStoreTypes()
        await this._listResourceStoreUseRecords()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async getDictData() {
      try {
        const data = await getDict('resource_store_use_record', 'state')
        this.resourceStoreUseRecordManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listResourceStoreUseRecords() {
      try {
        this.loading = true
        this.hasError = false
        const params = {
          page: this.page.current,
          row: this.page.size,
          ...this.resourceStoreUseRecordManageInfo.conditions
        }
        const { data, total } = await listResourceStoreUseRecords(params)
        this.resourceStoreUseRecordManageInfo.resourceStoreUseRecords = data
        this.resourceStoreUseRecordManageInfo.total = total
      } catch (error) {
        console.error(error)
        this.hasError = true
        this.errorMessage = this.$t('common.loadError')
      } finally {
        this.loading = false
      }
    },
    async _listResourceStoreTypes() {
      try {
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId,
          parentId: '0'
        }
        const { data } = await listResourceStoreTypes(params)
        this.resourceStoreUseRecordManageInfo.resourceStoreTypes = data
      } catch (error) {
        console.error(error)
      }
    },
    async _listResourceStoreSonTypes() {
      try {
        this.resourceStoreUseRecordManageInfo.conditions.rstId = ''
        this.resourceStoreUseRecordManageInfo.resourceStoreSonTypes = []
        if (!this.resourceStoreUseRecordManageInfo.conditions.parentRstId) return
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId,
          parentId: this.resourceStoreUseRecordManageInfo.conditions.parentRstId
        }
        const { data } = await listResourceStoreTypes(params)
        this.resourceStoreUseRecordManageInfo.resourceStoreSonTypes = data
      } catch (error) {
        console.error(error)
      }
    },
    async _listResourceStoreSpecifications() {
      try {
        this.resourceStoreUseRecordManageInfo.resourceStoreSpecifications = []
        this.resourceStoreUseRecordManageInfo.conditions.rssId = ''
        if (!this.resourceStoreUseRecordManageInfo.conditions.rstId) return
        const params = {
          page: 1,
          row: 100,
          communityId: this.communityId,
          rstId: this.resourceStoreUseRecordManageInfo.conditions.rstId
        }
        const { data } = await listResourceStoreSpecifications(params)
        this.resourceStoreUseRecordManageInfo.resourceStoreSpecifications = data
      } catch (error) {
        console.error(error)
      }
    },
    _queryResourceStoreUseRecordMethod() {
      this.page.current = 1
      this._listResourceStoreUseRecords()
    },
    _resetResourceStoreUseRecordMethod() {
      this.resourceStoreUseRecordManageInfo.conditions = {
        rsurId: '',
        repairId: '',
        resId: '',
        resName: '',
        parentRstId: '',
        rstId: '',
        rssId: '',
        createUserId: '',
        createUserName: '',
        startTime: '',
        endTime: '',
        state: '',
        userId: this.resourceStoreUseRecordManageInfo.conditions.userId,
        userName: this.resourceStoreUseRecordManageInfo.conditions.userName,
        communityId: this.communityId
      }
      this.resourceStoreUseRecordManageInfo.resourceStoreSonTypes = []
      this.resourceStoreUseRecordManageInfo.resourceStoreSpecifications = []
      this.page.current = 1
      this._listResourceStoreUseRecords()
    },
    _moreCondition() {
      this.resourceStoreUseRecordManageInfo.moreCondition = !this.resourceStoreUseRecordManageInfo.moreCondition
    },
    async _exportExcel() {
      try {
        this.loading = true
        const params = {
          pagePath: 'resourceStoreUseRecordManage',
          ...this.resourceStoreUseRecordManageInfo.conditions
        }
        await exportData(params)
        this.$message.success(this.$t('common.operationSuccess'))
        this.$router.push('/pages/property/downloadTempFile?tab=下载中心')
      } catch (error) {
        console.error(error)
        this.$message.error(this.$t('common.exportFailed'))
      } finally {
        this.loading = false
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listResourceStoreUseRecords()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listResourceStoreUseRecords()
    }
  }
}
</script>

<style lang="scss" scoped>
.resource-store-use-record-manage-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
</style>
